import React, { useEffect, useState } from "react";
import { useNotificationContext } from "../../../common/NotificationContext";
import { useLoading } from "../../../common/LoadingContext";
import {
  VendorListingService,
  VendorListingSearchService,
  VendorAndSupplierTypeListingService,
} from "../../../services/VendorService";
import VendorList from "./VendorList";
import useGlobalState from "../../../Context";

const Vendor = () => {
  const [vendorList, setVendorList] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [typeList, setTypeList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;

  useEffect(() => {
    fetchVendorDetails("name", false);
  }, []);

  const fetchVendorDetails = async (sortBy, isAsc,searchValue,paginationObject) => {
    try {
      setLoading(true);
      const requestBody = {
        active: loginUserType === "Main Admin" ? 2 : 0,
        pageNumber: paginationObject?.pageNumber ?? 0,
        pageSize: paginationObject?.pageSize ?? 10,
        filterSearch: searchValue ? searchValue : null,
        sortBy: sortBy,
        sortDirection: isAsc ? "DESC" : "ASC",
      };
      const vendorListingResponse = await VendorListingService(requestBody);
      if (vendorListingResponse.statusCode === 6) {
        if (vendorListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setVendorList(vendorListingResponse.data.content);
        setTotalElements(vendorListingResponse.data.totalElements);
      } else {
        showNotification("Error", vendorListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    searchValue
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        sortBy: orderBy,
        sortDirection: sortValue === null ? "DESC" : sortValue,
        active: loginUserType === "Main Admin" ? 2 : 0,
        filterSearch: searchValue ? searchValue.trim(): null,
      };
      const response = await VendorListingService(requestBody);
      if (response.statusCode === 6) {
        if (isUpdate) {
          setVendorList([...vendorList, ...response.data.content]);
        } else {
          setVendorList(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  const onSearchVendor = async (values, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        active: loginUserType === "Main Admin" ? 2 : 0,
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortBy: "name",
        sortDirection: "ASC",
      };
      const vendorListingResponse = await VendorListingSearchService(
        requestBody,
        searchValue
      );

      if (vendorListingResponse.statusCode === 6) {
        if (vendorListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setVendorList(vendorListingResponse.data.content);
        setTotalElements(vendorListingResponse.data.totalElements);
      } else {
        showNotification("Error", vendorListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const fetchTypeList = async () => {
    try {
      const typeListingResponse = await VendorAndSupplierTypeListingService();

      if (typeListingResponse.statusCode === 6) {
        setTypeList(typeListingResponse.data);
      } else {
        showNotification("Error", typeListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <VendorList
      totalElements={totalElements}
      vendorList={vendorList}
      typeList={typeList}
      fetchTypeList={fetchTypeList}
      fetchVendorDetails={fetchVendorDetails}
      handleTableChanges={handleTableChanges}
      setLoading={setLoading}
      showNotification={showNotification}
      onSearchVendor={onSearchVendor}
      setVendorList={setVendorList}
      noRecord={noRecord}
    />
  );
};

export default Vendor;
